export const SITE_NAME = "Brew Your Brand";
export const SITE_URL = "https://brewyourbrand.in";
export const DEFAULT_OG_IMAGE =
  "https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/og_arrow.png";
export const SITE_LOGO =
  "https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg";
export const HOMEPAGE_META_DESCRIPTION =
  "Explore Brew Your Brand for brand-building tools, quick assessment, eMagazine insights, and a founder-focused creative community.";
export const SITE_SOCIAL_PROFILES = [
  "https://www.linkedin.com/company/brew-your-brand",
  "https://www.instagram.com/brew_your_brand",
  "https://x.com/brew_your_brand",
];

export function getCurrentCanonicalPath() {
  if (typeof window !== "undefined" && window.location?.pathname) {
    return window.location.pathname || "/";
  }

  return "/";
}

export function toAbsoluteUrl(value = "/") {
  try {
    return new URL(value, SITE_URL).toString();
  } catch (error) {
    return SITE_URL;
  }
}

export function toCanonicalUrl(value = getCurrentCanonicalPath()) {
  try {
    const targetUrl = new URL(value || getCurrentCanonicalPath(), SITE_URL);
    const siteUrl = new URL(SITE_URL);

    targetUrl.protocol = siteUrl.protocol;
    targetUrl.host = siteUrl.host;
    targetUrl.hash = "";
    targetUrl.search = "";

    return targetUrl.toString();
  } catch (error) {
    return SITE_URL;
  }
}

export function stripHtml(value = "") {
  return value
    .replace(/<script[\s\S]*?<\/script>/gi, " ")
    .replace(/<style[\s\S]*?<\/style>/gi, " ")
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function truncateText(value = "", maxLength = 160) {
  const normalizedValue = value.replace(/\s+/g, " ").trim();

  if (!normalizedValue) {
    return "";
  }

  if (normalizedValue.length <= maxLength) {
    return normalizedValue;
  }

  return `${normalizedValue.slice(0, maxLength - 3).trimEnd()}...`;
}

export function toTitleCase(value = "") {
  return value
    .replace(/[-_]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

export function buildOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${SITE_URL}/#organization`,
    name: SITE_NAME,
    url: SITE_URL,
    logo: {
      "@type": "ImageObject",
      url: SITE_LOGO,
    },
    sameAs: SITE_SOCIAL_PROFILES,
  };
}

export function buildWebSiteSchema({ searchUrl } = {}) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${SITE_URL}/#website`,
    name: SITE_NAME,
    url: SITE_URL,
    publisher: {
      "@id": `${SITE_URL}/#organization`,
    },
  };

  if (searchUrl) {
    schema.potentialAction = {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: searchUrl,
      },
      "query-input": "required name=search_term_string",
    };
  }

  return schema;
}
